var sqlParser = require('sql-parser/browser/sql-parser')

const groupAndAggregate = require('./aggregate').groupAndAggregate
const aggregate = require('./aggregate').aggregate
const having = require('./aggregate').having
const where = require('./where').where
const soqlize = require('./soqlize')
const toOdata = require('./toOdata')
const orderBy = require('lodash/orderBy')

const query = (soql, data, fieldDescription = []) => {
  if (!data) return data
  data = data.slice(0)
  let ast
  let parse = sqlParser.parse || (sqlParser.SQLParser && sqlParser.SQLParser.parse)
  soql = soql.replace(/((NEXT|LAST)_N_[A-Z]+\:\d+)/g, '\'$1\'')
  try {
    ast = parse(soql)
  } catch (e) {
    console.log("Parser Error", e)
    throw e
  }

  if (ast.where && ast.where.conditions) data = where(data, ast.where.conditions, fieldDescription)
  if (ast.group && ast.group.fields && ast.group.fields.length) {

    const grp = ast.group && ast.group.fields.map(f => {
      let g = {}
      if (f.arguments && f.arguments.value && f.arguments.value.length > 0) {
        g.functionName = f.name
        g.fieldPathArray = f.arguments.value[0].values
      } else {
        g.fieldPathArray = f.values
      }
      return g
    })
    data = groupAndAggregate(data, ast.fields, grp, fieldDescription)
  } else {
    let aggFields = ast.fields && ast.fields.filter(f => f.field && f.field.arguments)
    if (aggFields && aggFields.length > 0) {
      data = aggregate(data, aggFields, [], fieldDescription)
    }
  }

  if (ast.group?.having?.conditions) {
    data = having(data, ast.group.having.conditions, fieldDescription)
  }

  if (ast.order?.orderings) {
    data = orderBy(
      data, 
      ast.order.orderings.map(x => typeof x.value?.value === 'string' ? d => d[x.value.value]?.toLowerCase?.() : x.value?.value ),
      ast.order.orderings.map(x => x.direction?.toLowerCase())
    )
  }

  if (ast.limit) data = data.slice(0, ast.limit.value)
  return data
}

module.exports = {
  query,
  aggregate,
  where,
  soqlize,
  toOdata
}
